import {vehicleStates} from '../../../constants/constants';
import blueTruck from './Markers/truckblue.png';
import redTruck from './Markers/truckred.png';
import greenTruck from './Markers/truckgreen.png';
import greenCar from './Markers/cargreen.png';
import redCar from './Markers/carred.png';
import blueCar from './Markers/carblue.png';
import blueBus from './Markers/busblue.png';
import redBus from './Markers/busred.png';
import greenBus from './Markers/busgreen.png';
import bikeBlue from './Markers/bike_blue.png';
import bikeGreen from './Markers/bike_green.png';
import bikeRed from './Markers/bike_red.png';
import _ from 'lodash';

var truckMarkers = {
    [vehicleStates.RUNNING]: greenTruck,
    [vehicleStates.STOPPPED]: blueTruck,
    [vehicleStates.IMMOBILIZED]: redTruck,
    [vehicleStates.DEVICE_PULLOUT]: redTruck,
    [vehicleStates.NON_COMM]: redTruck,
}

var busMarkers = {
    [vehicleStates.RUNNING]: greenBus,
    [vehicleStates.STOPPPED]: blueBus,
    [vehicleStates.IMMOBILIZED]: redBus,
    [vehicleStates.DEVICE_PULLOUT]: redBus,
    [vehicleStates.NON_COMM]: redBus,
}

var carMarkers = {
    [vehicleStates.RUNNING]: greenCar,
    [vehicleStates.STOPPPED]: blueCar,
    [vehicleStates.IMMOBILIZED]: redCar,
    [vehicleStates.DEVICE_PULLOUT]: redCar,
    [vehicleStates.NON_COMM]: redCar,
}
var bikeMarkers = {
    [vehicleStates.RUNNING]: bikeGreen,
    [vehicleStates.STOPPPED]: bikeBlue,
    [vehicleStates.IMMOBILIZED]: bikeRed,
    [vehicleStates.DEVICE_PULLOUT]: bikeRed,
    [vehicleStates.NON_COMM]: bikeRed,
}

let customIconConfig = [
    vehicle=> {
        let gids = !vehicle.groups ? [] : vehicle.groups.map(g => g.name);
        _.each(vehicle.groups, g => {
            if(g.pname && !gids.includes(g.pname)) {
                gids.push(g.pname);
            }
        });
        let isKushal = gids.includes('KushalSSLLP');
        let iconType;
        if(window.userInfo.SELF && window.userInfo.SELF.vehicle_icon_select){
             iconType = window.userInfo.SELF.vehicle_icon_select.toLowerCase();
        }   
        if(gids.includes('nh100') || isKushal || iconType && iconType == 'dynamic') {
            //if(window.map.getZoom() < 13 && !isKushal) return;
            let scale = 2;
            let url;

            if(!vehicle.vehicleModel) return;
            if(vehicle.vehicleModel.vehicletype.toLowerCase() == 'car') {
                url = carMarkers;
            } else if(vehicle.vehicleModel.vehicletype.toLowerCase() == 'bus') {
                url = busMarkers;
            } else if(vehicle.vehicleModel.vehicletype.toLowerCase() == 'truck') {
                url = truckMarkers;
            }
            else if(vehicle.vehicleModel.vehicletype.toLowerCase() == 'bike') {
                url = bikeMarkers;
            }

            if(scale && url) return {scale, url}
        }
    }
]


export default (vehicle)=> {
    for(let idx in customIconConfig) {
        let customIcon = customIconConfig[idx](vehicle);
        if(customIcon) 
            return customIcon;
    }
}